const lang = (props) => {
    let translate = props.props
    const idioma = localStorage.getItem("lang") || "es"

    if (idioma === "es") {
        switch (translate) {
            case "Inicia sesión":
                break;
            case "para personalizar!":
                break;
            case "¿Prefieres cuenta de Google?":
                break;
            case "¿Prefieres cuenta para mecanews?":
                break;
            case "Nombre":
                break;
            case "Apellidos":
                break;
            case "Repite contraseña":
                break;
            case "Contraseña":
                break;
            case "Ya tienes cuenta?":
                break;
            case "No tienes cuenta?":
                break;
            case "Crear cuenta":
                break;
            case "Iniciar sesión":
                break;
            case "- Noticias populares -":
                break;
            case "Origen: ":
                break;
            case "Sigue leyendo":
                break;
            case "Escribe aquí!":
                break;
            case "Elige antes un texto!":
                break;
            case "Aprende":
                break;
            case "Practica":
                break;
            case "Compite":
                break;
            case "Colocación dedos":
                break;
            case "¡Es muy sencillo!":
                break;
            case "Elige filas":
                break;
            case "Si usas 2 dedos para escribir,":
                break;
            case "olvida tus hábitos y cambia, sin prisa,":
                break;
            case "por el dedo correcto para cada tecla.":
                break;
            case "Coloca los dedos índice (naranja y rosa)":
                break;
            case "en la f y j como punto de partida.":
                break;
            case "Trata de no mirar el teclado...":
                break;
            case "¡tienes otro en la pantalla si lo necesitas!":
                break;
            case "Vacío!":
                break;
            case "¡No tienes cartas!":
                break;
            case "Últimas noticias subidas:":
                break;
            case "No hay nada O.O":
                break;
            case "Volver":
                break;
            case "Crear carta":
                break;
            case "Funciona! Quieres añadirlo?":
                break;
            case "Si!":
                break;
            case "No, probar otro":
                break;
            case "De momento el enlace no es correcto...":
                break;
            case "Nombre de la página":
                break;
            case "Enlace a feed RSS":
                break;
            case "Tags (enter para añadir)":
                break;
            case "Noticias recientes de este enlace:":
                break;
            case "Has alcanzado tu límite!":
                break;
            case "¡Bienvenido a la sindicación de contenidos!":
                break;
            case "Quiero más páginas de noticias YA:":
                break;
            case "Copia los enlaces de páginas que ya han subido otros usuarios":
                break;
            case "Quiero noticias de una página en concreto:":
                break;
            case "Cómo en encontrar un link para crear una tarjeta:":
                break;
            case "Busca el RRS de tu página":
                break;
            case "Elige categoría (si las hay)":
                break;
            case "Copia el link de la página que encuentres y pégalo en tu lista":
                break;
            case "Ninguno coincide!":
                break;
            case "Cargando...":
                break;
            case "Cartas":
                break;
            case "Mías":
                break;
            case "Populares":
                break;
            case "Explorar":
                break;
            case "Mi cuenta":
                break;
            case "Ventajas cuenta editor:":
                break;
            case "Guardar noticias":
                break;
            case "Practicar por categorías":
                break;
            case "Temas (fuente, fondo...)":
                break;
            case "Añadir canales noticias":
                break;
            case "Permite almacenar varias noticias para practicar. Se pueden conseguir más con el tipo de cuenta, y según el rango de competitivo":
                break;
            case "Practicar por categoría como \"deportes\" en vez de con páginas de noticias":
                break;
            case "Personaliza el tipo de fuente y los fondos. Puedes verlo más abajo":
                break;
            case "Permite almacenar varias noticias a la hora de practicar. Se pueden conseguir más con el tipo de cuenta, y según el rango de competitivo":
                break;
            case "Texto ejemplo ":
                break;
            case "¡Contacta con el desarrollador!":
                break;
            case "Cualquier sugerencia o comentario es bienvenido :D":
                break;
            case "Cerrar sesión":
                break;
            case "Ventajas por competitivo:":
                break;
            case "Resultado: ":
                break;
            case "+ Noticias":
                break;
            case "Empezar":
                break;
            case "Puntos en juego: ":
                break;
            case "¡Has ganado!":
                break;
            case "Empate! Y mira que es difícil...":
                break;
            case "Perdiste...":
                break;
            case "Tú":
                break;
            case "Oponente":
                break;
            case "Points":
                break;
            case "Ver noticia":
                break;
            case "PPM Medio histórico: ":
                break;
            case "Media 5: ":
                break;
            case "Inicia sesión!":
                break;
            case "Noticias guardadas: ":
                break;
            case "Probando...":
                break;
            case "¿Seguro que quieres atacar a":
                break;
            case "MecaNews facilita el uso inalterado de contenido RSS explícitamente añadido por el usuario final. En todo momento se especifica el origen de la información y, además, se incluye enlace al contenido original fomentando su uso. De no estar de acuerdo éste, contactar al email indicado para bloquear el uso por parte de cualquier usuario de tu contenido RSS":
                break;
            case "Idioma":
                break;
            case "Sin resultados! El tag debe existir":
                break;
            case "Buscar por tag: Youtube...":
                break;
            case "Por ser usuario de la versión beta... ":
                break;
            case "Te damos cuenta de editor gratis!!!":
                break;
            case "Gratis y desbloqueado para siempre":
                break;
            case "Desbloquear":
                break;
            case "Temas":
                break;
            case "Contacto":
                break;
            case "Imagen de fondo":
                break;
            case "Tipografía":
                break;
            case "¡Necesitas cartas!":
                break;
            case "¡Aquí puedes crear cartas que no estén en mecanews!":
                break;
            case "Si solo quieres añadir otra que ya exista, busca en la sección de explorar":
                break;
            case "Historial":
                break;
            case "Clasificación":
                break;
            default:

        }
    } else if (idioma === "en") {
        switch (translate) {
            case "Inicia sesión":
                translate = "Log in"
                break;
            case "para personalizar!":
                translate = "to get custom news!"
                break;
            case "¿Prefieres cuenta de Google?":
                translate = "Want to use Google account?"
                break;
            case "¿Prefieres cuenta para mecanews?":
                translate = "Want to use MecaNews account?"
                break;
            case "Nombre":
                translate = "Name"
                break;
            case "Apellidos":
                translate = "Surname"
                break;
            case "Repite contraseña":
                translate = "Repeat password"
                break;
            case "Contraseña":
                translate = "Password"
                break;
            case "Ya tienes cuenta?":
                translate = "Have an account?"
                break;
            case "No tienes cuenta?":
                translate = "Don't have an account?"
                break;
            case "Crear cuenta":
                translate = "Create account"
                break;
            case "Iniciar sesión":
                translate = "Log in"
                break;
            case "- Noticias populares -":
                translate = "- Popular News -"
                break;
            case "Origen: ":
                translate = "Source: "
                break;
            case "Sigue leyendo":
                translate = "Read more"
                break;
            case "Escribe aquí!":
                translate = "Type here!"
                break;
            case "Elige antes un texto!":
                translate = "Choose text!"
                break;
            case "Aprende":
                translate = "Learn"
                break;
            case "Practica":
                translate = "Practice"
                break;
            case "Compite":
                translate = "Compete"
                break;
            case "Colocación dedos":
                translate = "Finger placement"
                break;
            case "¡Es muy sencillo!":
                translate = "It's easy!"
                break;
            case "Elige filas":
                translate = "Choose rows"
                break;
            case "Si usas 2 dedos para escribir,":
                translate = "If you still type with 2 fingers"
                break;
            case "olvida tus hábitos y cambia, sin prisa,":
                translate = "reset habits and start using the correct ones."
                break;
            case "por el dedo correcto para cada tecla.":
                translate = ""
                break;
            case "Coloca los dedos índice (naranja y rosa)":
                translate = "Place your index fingers (orange and pink)"
                break;
            case "en las teclas \"f\" y \"j\" como punto de partida.":
                translate = "in the \"f\" and \"j\" keys as a reference."
                break;
            case "Trata de no mirar el teclado...":
                translate = "Try not to look at the keyboard..."
                break;
            case "¡tienes otro en la pantalla si lo necesitas!":
                translate = "you can look at the one on the screen if you need to!"
                break;
            case "Vacío!":
                translate = "Empty!"
                break;
            case "Últimas noticias subidas:":
                translate = "Latest news"
                break;
            case "No hay nada O.O":
                translate = "Nothing here O.O"
                break;
            case "Volver":
                translate = "Go back"
                break;
            case "Crear carta":
                translate = "Create card"
                break;
            case "Funciona! Quieres añadirlo?":
                translate = "It works! Want to add it?"
                break;
            case "Si!":
                translate = "Sure!"
                break;
            case "No, probar otro":
                translate = "No, try another one"
                break;
            case "De momento el enlace no es correcto...":
                translate = "Current link is not valid"
                break;
            case "Nombre de la página":
                translate = "Name"
                break;
            case "Enlace a feed RSS":
                translate = "RSS link"
                break;
            case "Tags (enter para añadir)":
                translate = "Tags (enter to add)"
                break;
            case "Noticias recientes de este enlace:":
                translate = "Latest news"
                break;
            case "Has alcanzado tu límite!":
                translate = "Can't add more!"
                break;
            case "¡Bienvenido a la sindicación de contenidos!":
                translate = "Welcome to Really Simple Syndication"
                break;
            case "Cómo en encontrar un link para crear una tarjeta:":
                translate = "How to find a link to crate any card"
                break;
            case "Busca el RRS de tu página":
                translate = "Search for the Rss link"
                break;
            case "Elige categoría (si las hay)":
                translate = "Choose category (if there is one)"
                break;
            case "Copia el link de la página que encuentres y pégalo en tu lista":
                translate = "Copy this link and paste it in the form above"
                break;
            case "Ninguno coincide!":
                translate = "No match!"
                break;
            case "Cargando...":
                translate = "Loading..."
                break;
            case "Mías":
                translate = "Mine"
                break;
            case "Populares":
                translate = "Popular"
                break;
            case "Explorar":
                translate = "Search"
                break;
            case "Mi cuenta":
                translate = "My account"
                break;
            case "Ventajas cuenta editor:":
                translate = "Editor's account benefits"
                break;
            case "Guardar noticias":
                translate = "Save news"
                break;
            case "Practicar por categorías":
                translate = "Practice by tags"
                break;
            case "Temas (fuente, fondo...)":
                translate = "Theme (font, background...)"
                break;
            case "Añadir canales noticias":
                translate = "Add new news"
                break;
            case "Ventajas por competitivo:":
                translate = "Competitive rewards"
                break;
            case "Permite almacenar varias noticias para practicar. Se pueden conseguir más con el tipo de cuenta, y según el rango de competitivo":
                translate = "You can save this number of news. You can get more by upgrading your account, or by getting a better ranked score"
                break;
            case "Practicar por categoría como \"deportes\" en vez de con páginas de noticias":
                translate = "You can practice by tags such as \"sports\" instead of choosing a news provider "
                break;
            case "Personaliza el tipo de fuente y los fondos. Puedes verlo más abajo":
                translate = "Customize your font and background. You can change them below"
                break;
            case "Permite añadir nuevas noticias. Digamos que quieres usar noticias del Marca pero no está: con esto puedes añadir cualquier página que ofrezca RSS":
                translate = "You can add new news. Let's say you want news from \"The Telegraph\" but it's not added in MecaNews. You could now add any RSS source"
                break;
            case "Texto ejemplo ":
                translate = "Sample text"
                break;
            case "¡Contacta con el desarrollador!":
                translate = "Contact the developer!"
                break;
            case "Cualquier sugerencia o comentario es bienvenido :D":
                translate = "Any feedback will be appreciated :D"
                break;
            case "Cerrar sesión":
                translate = "Log out"
                break;
            case "Resultado: ":
                translate = "Result: "
                break;
            case "¡No tienes cartas!":
                translate = "No cards added"
                break;
            case "Cartas":
                translate = "Cards"
                break;
            case "Empezar":
                translate = "Start"
                break;
            case "Puntos en juego: ":
                translate = "Points at stake: "
                break;
            case "¡Has ganado!":
                translate = "Victory!"
                break;
            case "Empate! Sería más normal ver un unicornio...":
                translate = "Draw! Its easier to find a unicorn..."
                break;
            case "Perdiste...":
                translate = "You lost!"
                break;
            case "Tú":
                translate = "You"
                break;
            case "Oponente":
                translate = "Opponent"
                break;
            case "Puntos: ":
                translate = "Points: "
                break;
            case "Ver noticia":
                translate = "Go to article"
                break;
            case "PPM Medio histórico: ":
                translate = "Average WPM: "
                break;
            case "Media 5: ":
                translate = "Mean of 5: "
                break;
            case "Inicia sesión!":
                translate = "Log in to participate!"
                break;
            case "Noticias guardadas: ":
                translate = "Saved news: "
                break;
            case "Probando...":
                translate = "Testing: "
                break;
            case "¿Seguro que quieres atacar a ":
                translate = "Attack "
                break;
            case "MecaNews facilita el uso inalterado de contenido RSS explícitamente añadido por el usuario final. En todo momento se especifica el origen de la información y, además, se incluye enlace al contenido original fomentando su uso. De no estar de acuerdo éste, contactar al email indicado para bloquear el uso por parte de cualquier usuario de tu contenido RSS":
                translate = "MecaNews provides unaltered RSS content to users who explicitly ask for it. Content provider is ALWAYS shown, and there will always be a link to their page in order to encourage its use. If you are not ok with it, we can block any user to access your RSS content, just let us know at the email below."
                break;
            case "Idioma":
                translate = "Language"
                break;
            case "Sin resultados! El tag debe existir":
                translate = "Nothing found! Tag must exist"
                break;
            case "Buscar por tag: Youtube...":
                translate = "Search by tag: Youtube..."
                break;
            case "Por ser usuario de la versión beta... ":
                translate = "Just for being a beta tester..."
                break;
            case "Te damos cuenta de editor gratis!!!":
                translate = "We are giving editor accounts for free!!!"
                break;
            case "Gratis y para siempre":
                translate = "Free and forever"
                break;
            case "Desbloquear":
                translate = "Unlock"
                break;
            case "Temas":
                translate = "Themes"
                break;
            case "Contacto":
                translate = "Contact"
                break;
            case "Imagen de fondo":
                translate = "Background image"
                break;
            case "Tipografía":
                translate = "Typography"
                break;
            case "¡Necesitas cartas!":
                translate = "You need some cards!"
                break;
            case "¡Aquí puedes crear cartas que no estén en mecanews!":
                translate = "¡This is where you can create new cards!"
                break;
            case "Si solo quieres añadir otra que ya exista, busca en la sección de explorar":
                translate = "If you want to add and existing one, just go to the search section"
                break;
            case "Historial":
                translate = "Records"
                break;
            case "Clasificación":
                translate = "Leaderboard"
                break;
            default:
                translate = "Not translated"
        }
    }
    return (translate)
}

export default lang